module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"title":"Kur nukeliauja elektra?","subtitle":"Dvipusės apskaitos pavyzdys"}}')
  delete Component.options._Ctor
}
